import React from 'react';
import SelectorPersonas from './SelectorPersonas';

/**
 * Paso 6 — Usuarios (los que reciben la intervención).
 *
 * Los usuarios SIEMPRE son del ámbito de la campaña:
 *   - campaña interna     → personas
 *   - campaña colaborador → personas_colaboradoras
 *
 * Exclusión de técnicos:
 *   - Si campaña interna: ambos son internos, evitamos solape.
 *   - Si campaña colaborador: técnicos (internos) y usuarios (colaboradores)
 *     viven en tablas distintas, no hay solape posible → excluirIds=[].
 */
export default function Paso6Usuarios({ payload, errores, dispatch, dosColumnas = false }) {
  const esColaborador = payload.ambito === 'colaborador';

  return (
    <div className={dosColumnas ? 'space-y-3' : 'space-y-3 max-w-4xl'}>
      <p className="text-sm text-slate-500">
        Selecciona las personas que recibirán la intervención. Cada una podrá
        reservar su cita dentro del rango configurado.
      </p>
      <SelectorPersonas
        rol="usuario"
        ambito={payload.ambito}
        excluirIds={esColaborador ? [] : payload.tecnicos_ids}
        seleccionados={payload.usuarios_ids}
        cache={payload._usuarios_cache}
        onAdd={(persona) =>
          dispatch({ type: 'PERSONA_ADD', rol: 'usuario', persona })
        }
        onRemove={(id) =>
          dispatch({ type: 'PERSONA_REMOVE', rol: 'usuario', id })
        }
        errores={errores}
        dosColumnas={dosColumnas}
      />
    </div>
  );
}
